import React from 'react';
import ScientificSpiritDetector from './components/ScientificSpiritDetector';

const App = () => {
  return <ScientificSpiritDetector />;
};

export default App;

// DONE